module.exports = __webpack_public_path__ + "img/gooday-simplewhitelogo.3cef3342.png";